import Button from "../../Button"
import ImageTextComponent from "../../ImageTextComponent"
import { InstructionComponentProps } from "../InstructionComponent"
import IOS_QR_Code from "../../../resources/tutorial/OURA_APPLE_QRCode.png"
import ANDROID_QR_Code from "../../../resources/tutorial/OURA_ANDROID_QRCode.png"

const OuraSetupInstructionPart1: InstructionComponentProps = {
  name: "Oura Ring Setup – Teil 1",
  path: "/help/patient/oura/part1",
  description: "Erster Schritt zur Einrichtung des Oura Rings. Bitte laden Sie die Oura App aus dem App Store (für iOS) oder bei Google Play (für Android) herunter.",
  ios: {
    steps: [
        <ImageTextComponent
            text={
                <>
                    Die Oura-App kann auch bequem im Apple App Store heruntergeladen werden. 
                </>
            }button={
                <><Button
                    onClick={() => window.open(
                        "https://apps.apple.com/de/app/oura/id1043837948",
                        "_blank"
                    )}
                >
                    Zur App im Store
                </Button>
                <img
                        src={IOS_QR_Code}
                        alt="QR‑Code zur DOOR Studie Connect‑App (iOS)"
                        style={{ marginTop: 8, width: "30vw", maxWidth: 150, height: "auto" }}/></>
            }
            images={[]}
        />,
        <ImageTextComponent
            text={
                <>
                   Einmal heruntergeladen, können Sie sich auch hier mit den Anmeldedaten, die Sie vom Studienteam erhalten werden, in der App einloggen. 
                   Die Anmeldedaten erhalten Sie vom Studienteam vor Ort in der Arztpraxis und sind die selben wie für DOOR Studie Connect.
                </>
                }
            images={[]}
        />,
    ]
},
android: {
    steps: [
        <ImageTextComponent
            text={
                <>
                    Die Oura-App kann auch bequem im Google Play Store heruntergeladen werden.
                </>
            }button={
                <><Button
                    onClick={() => window.open(
                        "https://play.google.com/store/apps/details?id=com.ouraring.oura&hl=de",
                        "_blank"
                    )}
                >
                    Zur App im Store
                </Button><img
                        src={ANDROID_QR_Code}
                        alt="QR‑Code zur Oura‑App (Android)"
                        style={{ marginTop: 8, width: "30vw", maxWidth: 150, height: "auto" }} /></>
            }
            images={[]}
        />,
        <ImageTextComponent
            text={
                <>
                   Einmal heruntergeladen, können Sie sich auch hier mit den Anmeldedaten, die Sie vom Studienteam erhalten werden, in der App einloggen. 
                   Die Anmeldedaten erhalten Sie vom Studienteam vor Ort in der Arztpraxis und sind die selben wie für DOOR Studie Connect.
                </>
            }
            images={[]}
        />
    ]
}
}

export default OuraSetupInstructionPart1
